import { Card, Employee } from "@/types/v2";
import { getEmployeeName } from "@/lib/employees";

export interface RoTechnicianAndAdvisorProps {
  cardData: Card;
  employees?: Employee[];
}

export const RoTechnicianAndAdvisor = ({
  cardData,
  employees,
}: RoTechnicianAndAdvisorProps) => (
  <div className="grid grid-cols-2 gap-x-4 gap-y-2 rounded-lg border border-slate-200 bg-white p-3 text-sm text-foreground shadow-sm">
    <div>
      <h3 className="text-xs font-semibold uppercase text-muted-foreground">
        Technician
      </h3>
      <p className="font-medium">
        {getEmployeeName(cardData.technicianId, employees ?? [])}
      </p>
    </div>
    <div>
      <h3 className="text-xs font-semibold uppercase text-muted-foreground">
        Service Advisor
      </h3>
      <p className="font-medium">
        {getEmployeeName(cardData.serviceWriterId, employees ?? [])}
      </p>
    </div>
  </div>
);
